/**
 * One item with today's target in place of the plan's, marked with the reason.
 * An item no adjustment names comes back as it was, without an `adjusted` key
 * at all — so an unadjusted row has nothing to render and nothing to announce.
 * The engine emits AT MOST ONE adjustment per item, carrying the cut that
 * produced the count (`todayAdjustments`), so the first match is the only
 * match and its reason is the one that moved the number.
 */
export function adjustTargetSets(item, adjustments) {
    const adjustment = adjustments.find((candidate) => candidate.itemId === item.itemId);
    if (adjustment === undefined) {
        return item;
    }
    return {
        ...item,
        adjusted: {
            cutPct: adjustment.cutPct,
            reasonKey: adjustment.reasonKey,
            rirIncrease: adjustment.rirIncrease,
        },
        targetSets: adjustment.targetSets,
    };
}
/** Every row of the overview, through `adjustTargetSets`. */
export function applyAdjustments(items, adjustments) {
    return items.map((item) => adjustTargetSets(item, adjustments));
}
/**
 * The params a readiness reason's copy needs — `{ pct }`, straight off the
 * adjustment — or `undefined` when the server did not send one, which the
 * renderer turns into silence rather than a sentence with a hole in it.
 */
export function readinessReasonParams(adjustment) {
    const pct = adjustment.cutPct;
    return pct === undefined ? undefined : { pct };
}
/**
 * The distinct reasons behind today's adjustments, in first-seen order: one
 * caption line each at the top of the overview. Readiness applies to every
 * item at once, so six adjusted rows share one reason and the overview says
 * it once rather than six times. Under both a poor night and a high-stress
 * day that is a single line — the engine sends only the cut that moved the
 * counts, and a caption for the absorbed cut would claim a change it did
 * not make.
 */
export function adjustmentReasons(adjustments) {
    const seen = new Set();
    for (const adjustment of adjustments) {
        seen.add(adjustment.reasonKey);
    }
    return [...seen];
}
//# sourceMappingURL=readiness.js.map